import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";

import { SyncProgressBarComponent } from "./sync-progress-bar.component";
import { SyncProgressService } from "./sync-progress.service";

@NgModule({
  declarations: [SyncProgressBarComponent],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
  ],
  providers: [SyncProgressService],
  exports: [SyncProgressBarComponent],
})
export class SyncProgressModule {}
